import dayjs from "dayjs";

import { translate } from "app/filters/i18nFilter";
import CountryService from "app/services/CountryService";
import { allTrackers } from "app/services/track/track";
import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";
import type { Filter } from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import type { SwitcherItem } from "../../../types";
import { ESourceType } from "../../../types";

export const getSubtitleFilters = (country: number | null): Filter[] => {
    const countryName = country && CountryService.getCountryById(country)?.text;
    const from = dayjs.utc().subtract(3, "months").format("YYYY|MM|DD");
    const to = dayjs.utc().subtract(1, "months").endOf("month").format("YYYY|MM|DD");

    return [
        {
            filter: "date",
            value: { to, from },
            label: `(${translate("analysis.source.search.overview.search.competitors.last.three.months")})`,
        },
        { filter: "country", countryCode: country, value: countryName },
        { filter: "webSource", value: "Total" },
    ];
};

export const getFooterButtonConfig = (params: Record<string, any>) => [
    {
        type: buttonTypes.FLAT,
        text: translate("analysis.source.search.overview.search.competitors.cta.button"),
        link: proNavigator.href("organicsearch_websites-competitorsKeywords", { ...params }),
        onClick: () => allTrackers.dispatchTrackEvent("Internal Link", "click", "Performance/Search Competitors"),
        unlockHook: {
            component: "WsWebOrganicSearchCompetitors",
            hookModal: "organicKwCompetitors",
        },
    },
];

export const switcherItems: SwitcherItem[] = [
    { title: "website.analysis.search.overview.organic", value: ESourceType.ORGANIC, changeFilter: "Organic" },
];
